import { Box } from '@mantine/core';

export const AuditApps = () => {
  // @todo
  return <Box>Coming soon</Box>;
};
